import { PdApiActions, PdApiActionsEnum } from "../actions/pdApiActions";
import { translationStatusFilterOptionsInitialState } from "./initialState";

const translationStatusFilterReducer = (
  state: State.TranslationStatusFilterOptions = translationStatusFilterOptionsInitialState,
  action: PdApiActions
): State.TranslationStatusFilterOptions => {
  switch (action.type) {
    case PdApiActionsEnum.SET_TRANSLATION_STATUS_FILTER_OPTIONS: {
      const updated = action.payload;
      return { ...state, ...updated };
    }
    default:
      return state;
  }
};

export default translationStatusFilterReducer;
